
<template>
  <div class="toast">
    <p>このインスタンスのLTL/FTLを見るには認証が必要なようです。</p>
    <p>「インスタンスで認証する」とタイムラインを見られます。Bearer Token を手動で入力してもかまいません。</p>
    <p>すでに Bearer Token を入力している場合、Bearer Token が不正でないか確認してください。</p>
    <!-- Mastodon v3.0.0から、インスタンスの設定によってはLTL/FTL取得に認証が必要になりました。 -->
  </div>
</template>
